import React from 'react';
import type { TextProps } from 'react-native';
import { Text as NNText } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import type { TxKeyPath } from '@/core/i18n';
import { translate } from '@/core/i18n';

export type TextType =
  | 'largeTitle'
  | 'title1'
  | 'title2'
  | 'bodyRegular'
  | 'bodyBold'
  | 'caption1'
  | 'caption1Bold'
  | 'caption2'
  | 'caption2Bold';

interface Props extends TextProps {
  tx?: TxKeyPath;
  values?: any;
  type?: TextType;
}

export const Text = ({
  style,
  tx,
  children,
  type,
  values,
  ...props
}: Props) => {
  const { styles } = useStyles(stylesheet);

  return (
    <NNText style={[styles.text, type && styles[type], style]} {...props}>
      {tx ? translate(tx, values) : children}
    </NNText>
  );
};

const stylesheet = createStyleSheet((theme) => ({
  text: {
    fontFamily: 'DMSans-Regular',
    color: theme.colors.text.primary,
    userSelect: 'text',
  },
  largeTitle: {
    fontFamily: 'DMSans-Regular',
    fontSize: 36,
    fontWeight: 400,
    lineHeight: 43.2,
    letterSpacing: 0.4,
  },
  title1: {
    fontFamily: 'DMSans-Regular',
    fontSize: 24,
    fontWeight: 500,
    lineHeight: 28.8,
  },
  title2: {
    fontFamily: 'DMSans-Regular',
    fontSize: 20,
    fontWeight: 500,
    lineHeight: 24,
  },
  bodyRegular: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 22.4,
  },
  bodyBold: {
    fontFamily: 'DMSans-SemiBold',
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 22.4,
  },
  caption1: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 16,
  },
  caption1Bold: {
    fontFamily: 'DMSans-SemiBold',
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 16,
  },
  caption2: {
    fontSize: 11,
    fontWeight: 400,
    lineHeight: 13,
    letterSpacing: 0.06,
  },
  caption2Bold: {
    fontFamily: 'DMSans-SemiBold',
    fontSize: 11,
    fontWeight: 500,
    lineHeight: 13,
    letterSpacing: 0.06,
  },
}));
